import React from "react";
import * as yup from "yup";
import {View, Form, Text, FormGroup, SubmitButton, TextInput, Stack} from "@unibuddy/patron";
import {useCommunityRequestPasswordResetMutation} from "ubcommunity-shared/src/types";
import {useParams} from "react-router";

export function RequestResetPasswordForm() {
    const [requestReset, {loading, called}] = useCommunityRequestPasswordResetMutation();
    const {universitySlug} = useParams<{universitySlug?: string}>();
    const hasSubmitted = !loading && called;
    async function handleSubmit({email}, {setSubmitting}) {
        try {
            await requestReset({
                variables: {
                    email,
                    redirectUrl: universitySlug ? `/u/${universitySlug}/auth/login` : "",
                },
            });
            setSubmitting(false);
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <View padding="medium" paddingY="large">
            {hasSubmitted ? (
                <Text>
                    We have sent you an email to reset your password. Please check your inbox and
                    click the link in the email to proceed.
                </Text>
            ) : (
                <Form
                    onSubmit={handleSubmit}
                    initialValues={{email: ""}}
                    validationSchema={{email: yup.string().email().required()}}
                >
                    <Stack space="large">
                        <FormGroup label="Email">
                            <TextInput name="email" />
                        </FormGroup>
                        <SubmitButton block>Request Reset Password</SubmitButton>
                    </Stack>
                </Form>
            )}
        </View>
    );
}
